import React from "react";
import { routePortals } from "../configs/constant";

const OrderMeals = React.lazy(() => import("../pages/portal/OrderMealsPage"));
const OfferMeals = React.lazy(() => import("../pages/portal/OfferMealsPage"));
const KitChen = React.lazy(() => import("../pages/portal/KitchenPage"));
const ChangeOrder = React.lazy(
	() => import("../pages/portal/ChangeOrderDatePage")
);
const OutPutMenu = React.lazy(() => import("../pages/portal/OutPutMenuPage"));

const reviewSurvey = React.lazy(
	() => import("../pages/portal/reviewSurveyPage")
);
const Rating = React.lazy(() => import("../pages/portal/RatingPage"));
const MealCard = React.lazy(() => import("../pages/portal/MealCardPage"));
const CancelMeal = React.lazy(() => import("../pages/portal/CancelMeals"));

export const routePortal = [
	{
		id: 1,
		route: routePortals.ORDER,
		component: OrderMeals,
		permission: "dashboard",
	},
	{
		id: 2,
		route: routePortals.OFFER,
		component: OfferMeals,
		permission: "dashboard",
	},
	{
		id: 3,
		route: routePortals.KITCHEN,
		component: KitChen,
		permission: "dashboard",
	},
	{
		id: 4,
		route: routePortals.CHANGE,
		component: ChangeOrder,
		permission: "dashboard",
	},
	{
		id: 5,
		route: routePortals.OUTPUT,
		component: OutPutMenu,
		permission: "dashboard",
	},
	{
		id: 6,
		route: routePortals.REVIEW,
		component: reviewSurvey,
		permission: "dashboard",
	},
	{
		id: 7,
		route: routePortals.RATING,
		component: Rating,
		permission: "dashboard",
	},
	{
		id: 8,
		route: routePortals.MEAL,
		component: MealCard,
		permission: "dashboard",
	},
	{
		id: 9,
		route: routePortals.CancelMeals,
		component: CancelMeal,
		permission: "dashboard",
	},
];
